<template>
  <div>
    <div style="margin-bottom:10px;">
      <el-input
        style="width:150px;"
        placeholder="请输入SN号"
        v-model="filterInput"
        clearable>
      </el-input>
    </div>
    <el-table
      :data="list"
      stripe>
      <el-table-column
        prop="snHex"
        label="SN号">
      </el-table-column>
      <el-table-column
        prop="pnHex"
        label="PN号">
      </el-table-column>
      <!-- <el-table-column
        prop="systemName"
        label="子系统">
      </el-table-column> -->
      <el-table-column
        prop="snStatusName"
        label="SN状态">
      </el-table-column>
      <el-table-column
        prop="shipmentCount"
        label="出货次数">
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:10px;"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import http from 'http';
export default {
  props: ['id', 'systemList', 'detailDialog'],
  data () {
    return {
      filterInput: '',
      currentPage: 1,
      pageSize: 10,
      snStatus: {
        10: '已生成',
        20: '已烧录',
        21: '烧录中',
        22: '烧录失败',
        23: '烧录异常',
        30: '已激活'
      },
      tableData: []
    };
  },
  computed: {
    list () {
      let start = (this.currentPage - 1) * this.pageSize;
      let end = start + this.pageSize;
      return this.tableData.filter(item => item.snHex.indexOf(this.filterInput) !== -1).slice(start, end);
    },
    total () {
      return this.tableData.filter(item => item.snHex.indexOf(this.filterInput) !== -1).length;
    }
  },
  watch: {
    detailDialog () {
      this.currentPage = 1;
    },
    id () {
      this.getList(this.id);
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.currentPage = val;
    },
    async getList (id) {
      let { data } = await http.get(`/v1/shipment-logs/list-sns?shipmentId=${this.id}`);
      data.forEach(item => {
        item['snStatusName'] = this.snStatus[item.snStatus];
        this.systemList.forEach(subItem => {
          if (subItem.id === item.systemId) item['systemName'] = subItem['name'];
        });
      });
      this.tableData = data;
    }
  },
  async created () {
    this.getList(this.id);
  }
};
</script>



// WEBPACK FOOTER //
// src/views/shipment/child/detail.vue